import React from 'react';
import { Radar } from 'react-chartjs-2';
import {
  Chart as ChartJS, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend
} from 'chart.js';

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

export default function RadarChart({ labels, startupData, sectorAvg, startupName = 'Startup', height = 350, datasets: customDatasets }) {
  // If custom datasets provided (for multi-startup comparison), use them directly
  const datasets = customDatasets || [
    {
      label: startupName,
      data: startupData,
      backgroundColor: 'rgba(46, 117, 182, 0.2)',
      borderColor: '#2E75B6',
      borderWidth: 2,
      pointBackgroundColor: '#2E75B6',
      pointRadius: 4,
    },
    {
      label: 'Moyenne secteur',
      data: sectorAvg,
      backgroundColor: 'rgba(149, 165, 166, 0.15)',
      borderColor: '#95A5A6',
      borderWidth: 2,
      borderDash: [5, 5],
      pointBackgroundColor: '#95A5A6',
      pointRadius: 3,
    },
  ];

  const data = { labels, datasets };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      r: {
        min: 0,
        max: 10,
        ticks: { stepSize: 2, backdropColor: 'transparent', font: { size: 10 } },
        pointLabels: { font: { size: 11, weight: '500' }, color: '#2C3E50' },
        grid: { color: 'rgba(0,0,0,0.08)' },
      },
    },
    plugins: {
      legend: { position: 'bottom', labels: { padding: 20, usePointStyle: true, font: { size: 12 } } },
    },
  };

  return (
    <div style={{ height }}>
      <Radar data={data} options={options} />
    </div>
  );
}
